import { ScrollButton } from "../components/ScrollButton"
import SequentialScrollView from "../components/SequentialScrollView"
import { Box, CardMedia, Typography } from "@mui/material"

export const EndingSection = () => {

  const imageUrl = "/web-images/IMG_9387.jpg"

  const handleScrollUp = (e) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  return (
    <Box sx={{ position: "relative" }}>
      <ScrollButton onClick={(e) => handleScrollUp(e)} text="เลื่อนกลับขึ้นไป" scrollUp delay={5} />

      <SequentialScrollView
        components={[
          <Box>
            <Typography variant="h4">ขอบคุณที่อ่านมาจนจบนะ 💖</Typography>
            <Typography variant="h6" sx={{ mt: 2 }}>ขอโทษที่ทำของขวัญชิ้นนี้ช้าไปหน่อย</Typography>
          </Box>,
          <Box sx={{ textAlign: "center" }}>
            <Typography variant="h4">
              หวังว่าจะชอบของขวัญนี้นะ 💖
            </Typography>
            <CardMedia
              component="img"
              src={imageUrl}
              sx={{
                mt: 4,
                borderRadius: 3,
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                width: "300px",
                height: "300px",
                objectFit: "cover",
                mx: "auto",
              }}
            />
            <Typography variant="caption" component="div" sx={{ mt: 2 }}>
              me & u
            </Typography>
          </Box>
        ]}
        durations={[3200, 3000, 3000]}
      />
    </Box>
  )
}